/* eslint-disable */ 
import React from 'react'
import {
    BrowserRouter as Router,
    Route,
    Redirect,
    Switch,
} from 'react-router-dom';
import Signin from './Components/SignIn';
import Signup from './Components/Signup';
import Home from './Components/Home';
import WorkoutPage from './Components/WorkoutPage';
import ExercisePage from './Components/ExercisePage';
import ExerciseEdit from './Components/ExerciseEdit';
import Help from './Components/Help';
import NavBar from './Components/NavBar';
import ErrorBoundary from './Components/ErrorBoundary';
import AppError from './Components/AppError';
import SignOut from './Components/SignOut';
import NewWorkout from './Components/NewWorkout';
import WorkoutEdit from './Components/WorkoutEdit';
import './Components/components.css';
// <Route path="/" component={} />

function App() {
	return (
        <Router>
            <ErrorBoundary>
            <div className='app-container'>
                    <NavBar />
                {}
                <button className="fab-2025" onClick={()=>{const el=document.documentElement;const d=el.classList.toggle('dark');try{localStorage.setItem('theme', d?'dark':'light')}catch(_){}}}>
                </button>
                {/* Mobile bottom bar */}
                
                    <main id="main-content" role="main">
                        <Switch>
                        <Route exact path="/home" component={Home} />
                        <Redirect exact from="/" to="/home" />
                        <Route exact path="/sign-in" component={Signin} />
                        <Route exact path="/sign-up" component={Signup} />
                        <Route exact path="/new-workout" component={NewWorkout} />
                        <Route path="/workouts/:workoutId/exercises/:id/edit" component={ExerciseEdit} />
                        <Route path="/workouts/:workoutId/exercises/:id" component={ExercisePage} />
                        <Route path="/workouts/:id/edit" component={WorkoutEdit} />
                        <Route path="/workouts/:id" component={WorkoutPage} />
                        <Route exact path="/help" component={Help} />
                        <Route exact path="/sign-out" component={SignOut} />
                        <Route exact path="/error" component={AppError} />
                        <Redirect from="*" to="/error" />
                    </Switch>
                      </main>
                    {/*<AppFooter />*/}
            </div>
                    </ErrorBoundary>
        </Router>
	);
}


function ThemeToggleMobile(){
  const [label, setLabel] = React.useState('Dark Mode');
  React.useEffect(()=>{
    const isDark = document.documentElement.classList.contains('dark');
    setLabel(isDark ? 'Light Mode' : 'Dark Mode');
  },[]);
  const onClick = () => {
    const el = document.documentElement;
    const isDark = el.classList.toggle('dark');
    try { localStorage.setItem('theme', isDark ? 'dark' : 'light'); } catch(e) {}
    setLabel(isDark ? 'Light Mode' : 'Dark Mode');
  };
  return <button type="button" className="btn-2025" onClick={onClick} aria-pressed={label==="Light Mode"}>{label}</button>;
}

export default App;